import React, { useState, Fragment } from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Collapse from 'react-bootstrap/Collapse';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown'
import { useSelector, useDispatch } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faToggleOn, faToggleOff, faEllipsisH, faEye} from '@fortawesome/free-solid-svg-icons'

import {setViewportItemLastStateVisibility, setViewportItemTrajectoryVisibility,
  setViewportItemChartVisibility, setComparisonTimeVisibility, 
   } from '../state/viewportItemActions'
import {   setZoomToItem} from '../state/uiActions'

/**  */
export default function  ViewportItemRow(props) {

  // props: viewportItemIndex, viewportItemId, viewportItemKey, focused, 
  //        location, browserHistory
  //        map
  const id = props.viewportItemId ;
  const conf = useSelector((state) => state.ui.viewportItemConfigs[id]) ;
  const item = useSelector((state) => state.viewport.viewport.items[props.viewportItemIndex]) ;
  const lastStateVisible = useSelector((state) => state.ui.itemLastStateVisible[id]) ;
  const lastState = useSelector((state) => state.viewport.itemMoLastStates[id]) ;
  const firstState = useSelector((state) => state.viewport.itemMoFirstStates[id]) ;
  const trajectoryVisible = useSelector((state) => state.ui.itemTrajectoryVisible[id]) ;
  const comparisonTimeVisible = useSelector((state) => state.ui.itemComparisonTimeVisible[id]) ;
  const locations = useSelector((state) => state.viewport.itemMoLocations[id]) ;
  const stats = useSelector((state) => state.viewport.itemMoStats[id]) ;
  const chartVisible = useSelector((state) => state.ui.itemChartVisible[id]) ;
  const viewportItemNotes = useSelector((state) => state.ui.viewportItemNotes[id]) ;

  const profilePicture = ( conf ? conf.profilePicture : null) ;
  const profilePictureWidth =  ( ( conf ? conf.profilePictureWidth : null ) ? 
                                  conf.profilePictureWidth : PROFILE_PICTURE_WIDTH) ;
  const profilePictureOpacity =  (conf ? conf.profilePictureOpacity : null) ; 
  const directLink = (conf ? conf.directLink : null)

  const dispatch = useDispatch(); 

  const setLastStateVisibility = () => {
    dispatch( setViewportItemLastStateVisibility(id) )
  } ;
  const setTrajectoryVisibility = () => {
    dispatch( setViewportItemTrajectoryVisibility(id) )
  } ;
  const setChartVisibility = () => {
    dispatch( setViewportItemChartVisibility(id) )
  } ;
  const setComparisonTimeVisibility = () => {
        dispatch( setComparisonTimeVisibility(id) )
  } ;
  const zoomToItem= () => {
    dispatch( setZoomToItem(id) )
} ;

  // ---------------------------------------------------
  // ---------------------------------------------------

  // if ( id == 385 ) console.log("render")
  // set name to be displayed:
  var name = item.display_name ;
  if (name===null) name = item.short_name ;
  if (name===null) name = "id: " + id ;
  // button color is based on active map elements
  var variant = "outline-secondary" // text-left dropdown-toggle btn btn-block btn-sm"  ;
  if ( trajectoryVisible) variant = "success" ;
  else if ( lastStateVisible ) variant = "info" ;
  // dropdown menu, containing status toggle icons
  if ( lastStateVisible )
    var stateVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
  else
    stateVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
  if (trajectoryVisible )
    var trajectoryVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
  else
    trajectoryVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
  if ( chartVisible )
    var chartVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
  else
    chartVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
  if ( comparisonTimeVisible )
    var compVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOn} color="green"/> ;
  else
    compVisibleMenuIcon = <FontAwesomeIcon icon={faToggleOff} color="grey"/>
  // <h6 className="dropdown-header">megjelenítés: </h6>
  //<div id={"sliderElement-"+id}>
  //<Slider id={"sliderElement-"+id}/>
  //</div>
  return (
    <div>
      <Dropdown>
        <div className="d-grid gap-2"> 
          <Dropdown.Toggle id="dropdown-basic" className="menu-item-row btn-block btn-sm text-left" variant={variant}>
            {name} <span style={{ float: 'right' }}><FontAwesomeIcon icon={faEllipsisH} /> </span>
          </Dropdown.Toggle>
        </div>
        <Dropdown.Menu>
          <Dropdown.Item className="dropdown-item" href="#"
                         onClick={() => zoomToItem()}>
              <FontAwesomeIcon icon={faEye}/>  &nbsp; megmutat
          </Dropdown.Item>          
          <Dropdown.Item className="dropdown-item" href="#"
                         onClick={() => setLastStateVisibility()}>
              {stateVisibleMenuIcon} &nbsp; pozíció
          </Dropdown.Item>
          <Dropdown.Item className="dropdown-item" href="#"
                         onClick={() => setTrajectoryVisibility()}>
            {trajectoryVisibleMenuIcon} &nbsp; megtett út
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
  
        {/*<a className="dropdown-item" href="#"
           onClick={() => setChartVisibility()}>
          {chartVisibleMenuIcon} &nbsp; diagram
        </a>*/}
  {/*
        <a className="dropdown-item" href="#"
           onClick={() => setComparisonTimeVisibility()}>
          {compVisibleMenuIcon} &nbsp; legjobb idő diff.
        </a>
       <div className='m-1 pl-1 pr-1 pt-2 pb-2 alert alert-info'>
          <table className="mini"><tbody>
            <tr><td>adat: </td><td>
            {console.log(lastState)}
            {lastState ?
              (lastState.timeGenerated ?
                moment(parseInt(lastState.timeGenerated)).format('YYYY-MM-DD HH:mm'): '-'): '-'}
            </td></tr>
            <tr><td></td><td>
            {moment().diff( moment(parseInt(lastState ?
                                            lastState.timeGenerated : '?' )), 'minutes')} perce </td></tr>
            <tr><td>sebesség: </td><td>{lastState ?
                  (lastState.speed ? lastState.speed: '-'): '?'} km/h </td></tr>
            <tr><td>magasság: </td><td>{lastState ?
                  (lastState.altitude? lastState.altitude: '-'): '?'} m </td></tr>
          </tbody></table>
        </div>
        <div className='m-1 pl-1 pr-1 pt-2 pb-2 alert alert-light'>
          <div className='viewport-note'>
            {viewportItemNotes}
          </div>
        </div>
       */}

    </div>
  );
  //              <tr><td>aksi: </td><td>
  //                {Math.round(lastState ?
  //                            lastState:
  //                            lastState.batteryVoltage*100)/100} V</td></tr>


}
